import { getClient as e } from "../../util/reactQuery/index.js";
import { QueryClientProvider as t } from "@tanstack/react-query";
import { jsx as o } from "react/jsx-runtime";
const p = ({
  children: r
}) => /* @__PURE__ */ o(t, {
  client: e(),
  children: r
});
export {
  p as ReactQueryProvider
};
//# sourceMappingURL=ReactQueryContext.js.map
